import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { BaseAPI } from '../utils/Api';
import Notification from '../utils/Notification';

const AppTabPanel = () => {
  const { pathname } = useLocation();

  const [value, setValue] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    if (pathname.indexOf('category') === -1) {
      setValue(false);
    }
  }, [pathname]);

  useEffect(() => {
    BaseAPI.get('/dataset/category')
      .then((res) => {
        setCategoryList(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Notification(err?.response?.data?.message, 'error');
        } else {
          Notification('Something went wrong! Please try again');
        }
      });

    return () => {
      setCategoryList([]);
    };
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px', borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={value} onChange={handleChange} variant='scrollable' scrollButtons={false}>
        {categoryList?.map((el) => (
          <Tab key={el.id} value={el.url_name} label={el.name} to={`/category/${el.url_name}`} component={Link} />
        ))}
      </Tabs>
    </Box>
  );
};

export default AppTabPanel;
